import { render, staticRenderFns } from "./SpatialSpanWorkingMemory.vue?vue&type=template&id=2242e33e&scoped=true&"
import script from "./SpatialSpanWorkingMemory.vue?vue&type=script&lang=js&"
export * from "./SpatialSpanWorkingMemory.vue?vue&type=script&lang=js&"
import style0 from "./SpatialSpanWorkingMemory.vue?vue&type=style&index=0&id=2242e33e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242e33e",
  null
  
)

export default component.exports